import * as React from 'react';
import type { SVGProps } from 'react';

interface ProgressCircleIconProps extends SVGProps<SVGSVGElement> {
  innerFill?: string;
}

const SvgProgressCircleIcon = ({
  innerFill = '#fff',
  ...props
}: ProgressCircleIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <circle
      cx={9}
      cy={9}
      r={8}
      fill={innerFill}
      stroke="#F83"
      strokeDasharray="4 4"
      strokeWidth={2}
    />
  </svg>
);
export default SvgProgressCircleIcon;
